import { render, staticRenderFns } from "./SingleChoice.vue?vue&type=template&id=49176ec9&scoped=true"
import script from "./SingleChoice.vue?vue&type=script&lang=js"
export * from "./SingleChoice.vue?vue&type=script&lang=js"
import style0 from "./SingleChoice.vue?vue&type=style&index=0&id=49176ec9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49176ec9",
  null
  
)

export default component.exports